// Contrôleur d'images de variantes - Garantit l'affichage de l'image du produit par défaut
document.addEventListener('DOMContentLoaded', function() {
  
  // Forcer l'affichage de l'image principale du produit au chargement
  function ensureDefaultProductImage() {
    const activeSlides = document.querySelectorAll('.product__media-item.is-active[data-variant-image="true"]');
    
    // Si une image de variante est active par défaut, la désactiver
    activeSlides.forEach(slide => {
      slide.classList.remove('is-active');
    });

    // Activer l'image principale du produit
    const mainProductImage = document.querySelector('.product__media-item[data-is-main-product-image="true"]');
    if (mainProductImage && !mainProductImage.classList.contains('is-active')) {
      mainProductImage.classList.add('is-active');
    }
  }

  // Exécuter au chargement
  ensureDefaultProductImage();

  // Observer les changements dans la media gallery pour s'assurer de la cohérence
  const mediaGallery = document.querySelector('[id^="Slider-Gallery-"]');
  if (mediaGallery) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' || mutation.type === 'attributes') {
          // Petit délai pour laisser les autres scripts s'exécuter
          setTimeout(ensureDefaultProductImage, 50);
        }
      });
    });

    observer.observe(mediaGallery, {
      childList: true,
      attributes: true,
      attributeFilter: ['class'],
      subtree: true
    });
  }

  // Gérer les changements de variantes depuis d'autres sélecteurs
  document.addEventListener('change', function(e) {
    if (e.target.name === 'id' && e.target.form && e.target.form.dataset.type === 'add-to-cart-form') {
      // Un autre sélecteur de variante a changé, ne pas interférer avec notre système custom
      return;
    }
  });

  // Fonction utilitaire pour reset vers l'image du produit
  window.resetToProductImage = function() {
    const variantImages = document.querySelectorAll('.product__media-item[data-variant-image="true"]');
    const mainImage = document.querySelector('.product__media-item[data-is-main-product-image="true"]');
    
    variantImages.forEach(img => img.classList.remove('is-active'));
    if (mainImage) {
      mainImage.classList.add('is-active');
    }
  };

});